import axios from "../libs/axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1`;

class AllocationService {
  find(params) {
    return axios.get(`${API_URL}/allocations`, {
      headers: authHeader(),
      params: params,
    });
  }

  create(data) {
    return axios.post(`${API_URL}/allocation`, data, {
      headers: authHeader(),
    });
  }
  findByID(id) {
    return axios.get(`${API_URL}/allocation/${id}`, { headers: authHeader() });
  }

  update(data) {
    const _id = data._id;
    return axios.put(`${API_URL}/allocation/${_id}`, data, {
      headers: authHeader(),
    });
  }

  delete(id) {
    console.log("delete", id);
    return axios.delete(`${API_URL}/allocation/${id}`, {
      headers: authHeader(),
    });
  }

  async getTypes() {
    const response = await axios.get(`${API_URL}/allocation-types`, {
      headers: authHeader(),
    });
    return response.data;
  }
  async getStatuses() {
    const response = await axios.get(`${API_URL}/allocation-statuses`, {
      headers: authHeader(),
    });
    return response.data;
  }

  async checkStatuses() {
    const response = await axios.get(`${API_URL}/allocations-check-status`, {
      headers: authHeader(),
    });
    return response.data;
  }
}

export default new AllocationService();
